import { api } from "@/lib/api";

// ---------- Character Library ----------
// A reusable named cast (Bella, Benny, Mom, …) with optional
// reference photos that any channel kit, storyboard, or auto-video
// can pull from. Backed by Mongo + GridFS so uploads survive
// production redeploys (filesystem is ephemeral).

export const listCharacters = async () =>
  (await api.get("/characters")).data.characters;

export const createCharacter = async ({ name, description, role, tags }) =>
  (await api.post("/characters", { name, description, role, tags })).data;

export const updateCharacter = async (characterId, patch) =>
  (await api.patch(`/characters/${encodeURIComponent(characterId)}`, patch)).data;

export const deleteCharacter = async (characterId) =>
  (await api.delete(`/characters/${encodeURIComponent(characterId)}`)).data;

export const uploadCharacterImage = async (characterId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post(
    `/characters/${encodeURIComponent(characterId)}/images`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return res.data;
};

export const deleteCharacterImage = async (characterId, imageId) =>
  (await api.delete(
    `/characters/${encodeURIComponent(characterId)}/images/${encodeURIComponent(imageId)}`,
  )).data;

// Image URL the <img> tag uses. The backend serves bytes from GridFS
// with the original content-type, so the browser renders it natively
// without any /api/uploads disk mount.
export const characterImageUrl = (characterId, imageId) => {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}/api/characters/${encodeURIComponent(characterId)}/images/${encodeURIComponent(imageId)}`;
};
